export default __webpack_public_path__ + "static/media/pic57.25557d9e.jpg";